import styles from './styles.css';
import { FC, ReactNode } from 'react';
import { ISelectAgentBenefit } from '../../containers/SelectBestAgentContainer/types';
import { BenefitItem } from '../BenefitItem';
import { Button, useDeviceType } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';
import { QUALITY_DETAILS_ACTION_TITLE } from '../../containers/SelectBestAgentContainer/constants';

interface ISelectBestAgentProps {
  title: string;
  benefitsList: ISelectAgentBenefit[];
  handleOpen: () => void;
  modal?: ReactNode;
}

export const SelectBestAgent: FC<ISelectBestAgentProps> = ({ modal, title, benefitsList, handleOpen }) => {
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  return (
    <div className={clsx(styles['container'], styles[deviceType])}>
      <div className={clsx(styles['select-agent_content'], styles[deviceType])}>
        <div className={clsx(styles['agent-gallery'], styles[deviceType])}></div>
        <div className={clsx(styles['description'], styles[deviceType])}>
          <div className={clsx(styles['title'], styles[deviceType])}>{title}</div>
          {benefitsList && (
            <div className={styles['benefits_list']}>
              {benefitsList.map((point, index) => (
                <BenefitItem
                  key={index}
                  {...point}
                  icon={<point.icon color={isDesktop ? 'icon-secondary-default' : 'icon-main-default'} />}
                />
              ))}
            </div>
          )}
          <div className={clsx(styles['quality-details_action'], styles[deviceType])}>
            <Button
              onClick={handleOpen}
              theme={isDesktop ? 'fill_success_secondary' : 'fill_primary'}
              afterIcon={
                <IconFunctionalInformationCircle16
                  color={isDesktop ? 'icon-positive-default' : 'icon-inverted-default'}
                />
              }
              size={isDesktop ? 'M' : 'XS'}
            >
              {QUALITY_DETAILS_ACTION_TITLE}
            </Button>
          </div>
        </div>
      </div>
      {modal}
    </div>
  );
};
